<template>  <div>
    <v-toolbar
      dense
      tabs
      color="primary darken-2"
      dark
      class="page_title"
    >
      <v-toolbar-title class="pa-0 pr-0 mt-1">
        <v-layout row>
          <v-flex xs10 sm11 text-xs-left>
            <a href="javascript: history.go(-1)" class="pa-0">
              <v-btn flat fab small class="pa-0">
                <i class="fas fa-arrow-left headline"></i>
              </v-btn>
            </a>
            Payments
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
             <router-link :to="'/savings'" class="pa-0 text-xs-right">
              <v-btn flat fab small class="pa-0">
                <i class="fas fa-close headline"></i>
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tabs
        v-model="tabs"
        color="transparent"
        slider-color="white"
        slot="extension"
        grow
      >
        <v-tab
          v-for="tabsItem in tabsItems"
          :key="tabsItem.id"
          :to="tabsItem.link"
        >
          {{ tabsItem.title }}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <div class="payment-container">
        <v-card class="elevation-8" style="border-radius: 16px;">
            <!-- Header -->
            <v-card-title class="teal darken-2 white--text pa-4">
                <v-icon large color="white" class="mr-2">fas fa-credit-card</v-icon>
                <div>
                    <h2 class="headline mb-0">Make Payment</h2>
                    <p class="caption mb-0">Investment #{{ investment.id }}</p>
                </div>
            </v-card-title>

            <v-card-text class="pa-5">
                <!-- 🔥 PENDING TRANSACTIONS WARNING -->
                <v-alert v-if="pendingTransactions.length > 0" type="warning" class="mb-4" dismissible>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm8>
                            <strong>
                                <v-icon left>fas fa-hourglass-half</v-icon>
                                {{ pendingTransactions.length }} pending payment(s) awaiting validation
                            </strong>
                            <p class="mb-0 mt-2">
                                Total pending: <strong>{{ totalPendingAmount | formatAmount }} FCFA</strong>
                            </p>
                            <small class="grey--text">
                                These payments are being reviewed by a manager. You can still make a new payment if needed.
                            </small>
                        </v-flex>
                        <v-flex xs12 sm4 class="text-xs-right">
                            <v-btn small color="primary" text @click="showPendingDialog = true">
                                <v-icon small left>fas fa-list</v-icon>
                                View Details
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-alert>

                <!-- Investment Info -->
                <v-card class="mb-4 teal lighten-5" flat>
                    <v-card-text>
                        <v-layout row wrap align-center>
                            <v-flex xs12 sm6>
                                <div class="info-item">
                                    <v-icon color="teal darken-2">fas fa-wallet</v-icon>
                                    <span class="ml-2">Investment: {{ investment.investment_amount | formatAmount }} FCFA</span>
                                </div>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <div class="info-item">
                                    <v-icon :color="paymentType === 'monthly' ? 'purple' : 'green'">
                                        {{ paymentType === 'monthly' ? 'fas fa-calendar-alt' : 'fas fa-money-bill-wave' }}
                                    </v-icon>
                                    <span class="ml-2">
                                        {{ paymentType === 'monthly' ? `Month ${currentPayment.month_number}/10` : 'One-Time Payment' }}
                                    </span>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>

                <!-- Amount Details -->
                <v-card class="mb-4 pa-4" elevation="2">
                    <h3 class="mb-3">
                        <v-icon color="teal darken-2">fas fa-calculator</v-icon>
                        Payment Details
                    </h3>

                    <v-layout row wrap>
                        <v-flex xs6>
                            <p class="caption grey--text mb-1">Amount Due</p>
                            <p class="title mb-0">{{ totalDue | formatAmount }} FCFA</p>
                        </v-flex>


                        <v-flex xs6 v-if="totalPendingAmount > 0">
                            <p class="caption grey--text mb-1">Pending Validation</p>
                            <p class="title orange--text mb-0">{{ totalPendingAmount | formatAmount }} FCFA</p>
                        </v-flex>

                        <v-flex xs6 v-if="currentPayment && currentPayment.penalty_applied > 0">
                            <p class="caption grey--text mb-1">Late Penalty</p>
                            <p class="title red--text mb-0">+{{ currentPayment.penalty_applied | formatAmount }} FCFA</p>
                        </v-flex>

                        <v-flex xs6 v-if="remainingAmount > 0 || totalPendingAmount > 0">
                            <p class="caption grey--text mb-1">Still Needed</p>
                            <p class="title orange--text mb-0">{{ remainingAmount | formatAmount }} FCFA</p>
                        </v-flex>
                    </v-layout>

                    <v-divider class="my-3"></v-divider>

                    <!-- Total to Pay -->
                    <v-layout row wrap align-center>
                        <v-flex xs6>
                            <p class="headline font-weight-bold mb-0">Total to Pay</p>
                        </v-flex>
                        <v-flex xs6 class="text-xs-right">
                            <p class="display-1 teal--text text--darken-2 font-weight-bold mb-0">
                                {{ amountToPay | formatAmount }} FCFA
                            </p>
                        </v-flex>
                    </v-layout>
                </v-card>

                <!-- 🔥 PARTIAL PAYMENT OPTION (only for months 2-10) -->
                <v-card v-if="canMakePartialPayment || (totalPendingAmount > 0 && currentPayment.month_number > 1)" class="mb-4 pa-4 blue lighten-5" flat>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm8>
                            <h4 class="mb-2">
                                <v-icon color="blue darken-2">fas fa-info-circle</v-icon>
                                Payment Amount
                            </h4>
                            <p class="mb-0" v-if="totalPendingAmount > 0">
                                You have pending payments. You can make an additional payment if needed (e.g., if first payment was incorrect).
                            </p>
                            <p class="mb-0" v-else>
                                You can pay any amount. Minimum: {{ minPartialAmount | formatAmount }} FCFA
                            </p>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-text-field
                                v-model.number="customAmount"
                                label="Amount to Pay (FCFA)"
                                type="number"
                                outlined
                                dense
                                :min="minPartialAmount"
                                :max="totalDue"
                                @input="validateCustomAmount"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card>

                <!-- Alerts -->
                <v-alert v-if="currentPayment && currentPayment.is_late" type="error" class="mb-4">
                    <v-icon left>fas fa-exclamation-triangle</v-icon>
                    <strong>Late Payment!</strong> A penalty of {{ currentPayment.penalty_applied | formatAmount }} FCFA has been added.
                </v-alert>

                <v-alert v-if="currentPayment && currentPayment.month_number === 1" type="warning" class="mb-4">
                    <v-icon left>fas fa-clock</v-icon>
                    <strong>First Payment:</strong> Must be paid in full within 2 days. No partial payments allowed.
                </v-alert>

                <v-alert type="info" class="mb-4">
                    <v-icon left>fas fa-shield-alt</v-icon>
                    Your payment will be validated by a manager before being confirmed.
                </v-alert>

                <!-- Payment Form -->
                <v-card class="mb-4 pa-4" elevation="2">
                    <h3 class="mb-4">
                        <v-icon color="teal darken-2">fas fa-mobile-alt</v-icon>
                        Payment Information
                    </h3>

                    <!-- Phone Number -->
                    <v-text-field
                        v-model="phone_number"
                        label="Phone Number (Mobile Money)"
                        outlined
                        prepend-inner-icon="fas fa-phone"
                        placeholder="+237 XXX XXX XXX"
                        type="tel"
                        required
                        @click="clearPhoneField"
                    ></v-text-field>

                    <!-- Operator Selection -->
                    <p class="body-2 font-weight-medium mb-2">Select Operator</p>
                    <v-layout row wrap>
                        <v-flex xs6 class="pr-2">
                            <v-card
                                :class="['operator-card', { 'selected': momo_choice }]"
                                @click="selectMoMo"
                                hover
                            >
                                <v-card-text class="text-xs-center pa-3">
                                    <v-img
                                        :src="require('@/assets/mtn-mobile-money-logo.png')"
                                        contain
                                        height="60"
                                    ></v-img>
                                    <p class="caption font-weight-bold mt-2 mb-0">MTN MoMo</p>
                                    <v-icon v-if="momo_choice" color="teal" small>fas fa-check-circle</v-icon>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs6 class="pl-2">
                            <v-card
                                :class="['operator-card', { 'selected': om_choice }]"
                                @click="selectOM"
                                hover
                            >
                                <v-card-text class="text-xs-center pa-3">
                                    <v-img
                                        :src="require('@/assets/om.png')"
                                        contain
                                        height="60"
                                    ></v-img>
                                    <p class="caption font-weight-bold mt-2 mb-0">Orange Money</p>
                                    <v-icon v-if="om_choice" color="teal" small>fas fa-check-circle</v-icon>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card>

                <!-- Action Buttons -->
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="pr-sm-2 mb-2 mb-sm-0">
                        <v-btn
                            color="grey"
                            flat
                            large
                            block
                            @click="goBack"
                        >
                            <v-icon left>fas fa-arrow-left</v-icon>
                            Cancel
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 class="pl-sm-2">
                        <v-btn
                            color="teal darken-2"
                            class="white--text"
                            large
                            block
                            @click="confirmPayment"
                            :loading="isProcessing"
                            :disabled="!isFormValid"
                        >
                            <v-icon left>fas fa-check</v-icon>
                            Pay {{ finalAmount | formatAmount }} FCFA
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>

        <!-- 🔥 PENDING TRANSACTIONS DIALOG -->
        <v-dialog v-model="showPendingDialog" max-width="600">
            <v-card>
                <v-card-title class="orange darken-2 white--text">
                    <v-icon color="white" class="mr-2">fas fa-hourglass-half</v-icon>
                    Pending Payments
                </v-card-title>

                <v-card-text class="pa-4">
                    <v-alert type="info" dense class="mb-3">
                        These payments are awaiting manager validation. They will be added to your total once approved.
                    </v-alert>

                    <v-list>
                        <v-list-item
                            v-for="(trans, index) in pendingTransactions"
                            :key="index"
                            class="mb-2"
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                    <v-chip small color="orange" text-color="white" class="mr-2">
                                        Pending
                                    </v-chip>
                                    {{ trans.amount | formatAmount }} FCFA
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ trans.operator }} - {{ trans.phone_number }}<br>
                                    Ref: {{ trans.reference }}<br>
                                    <small class="grey--text">{{ trans.date }}</small>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-divider class="my-3"></v-divider>

                    <v-layout row wrap>
                        <v-flex xs6>
                            <p class="body-2 grey--text mb-0">Total Pending</p>
                        </v-flex>
                        <v-flex xs6 class="text-xs-right">
                            <p class="title orange--text font-weight-bold mb-0">
                                {{ totalPendingAmount | formatAmount }} FCFA
                            </p>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="showPendingDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Confirmation Dialog -->
        <v-dialog v-model="confirmDialog" max-width="500" persistent>
            <v-card>
                <v-card-title class="teal darken-2 white--text">
                    <v-icon color="white" class="mr-2">fas fa-check-circle</v-icon>
                    Confirm Payment
                </v-card-title>

                <v-card-text class="pa-4">
                    <v-card flat color="grey lighten-4" class="pa-3 mb-3">
                        <v-layout row wrap>
                            <v-flex xs6>
                                <p class="caption grey--text mb-1">Amount</p>
                                <p class="title font-weight-bold mb-0">{{ finalAmount | formatAmount }} FCFA</p>
                            </v-flex>
                            <v-flex xs6>
                                <p class="caption grey--text mb-1">Operator</p>
                                <p class="body-1 font-weight-bold mb-0">{{ transaction_operator }}</p>
                            </v-flex>
                            <v-flex xs12 class="mt-2">
                                <p class="caption grey--text mb-1">Phone</p>
                                <p class="body-1 font-weight-bold mb-0">{{ phone_number }}</p>
                            </v-flex>
                        </v-layout>
                    </v-card>

                    <v-alert type="info" dense>
                        <strong>Transfer Code:</strong>
                        <p class="display-1 text-xs-center red--text font-weight-bold my-2">{{ transfer_code }}</p>
                        <small>Dial this code to complete payment manually if auto-payment fails</small>
                    </v-alert>

                    <v-alert type="warning" dense v-if="pendingTransactions.length > 0">
                        <small>
                            <v-icon small left>fas fa-info-circle</v-icon>
                            This will create a new payment transaction. Your previous pending payments remain under review.
                        </small>
                    </v-alert>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="grey" text @click="confirmDialog = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <a id="dial_transaction" style="text-decoration: none;">
                        <v-btn
                            color="teal darken-2"
                            class="white--text"
                            @click="submitPayment"
                            :loading="isProcessing"
                        >
                            Confirm Payment
                        </v-btn>
                    </a>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div> </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            investment: {},
            currentPayment: null,
            paymentType: '',
            totalDue: 0,
            remainingAmount: 0,
            amountToPay: 0,

            // 🔥 NOUVEAU: Transactions en attente
            pendingTransactions: [],
            totalPendingAmount: 0,
            showPendingDialog: false,

            // Partial payment
            customAmount: 0,
            minPartialAmount: 0,

            // Form
            momo_choice: false,
            om_choice: false,
            phone_number: '',
            transaction_operator: '',
            payment_ref: '',

            // Processing
            confirmDialog: false,
            isProcessing: false,
            transfer_code: '',
            phoneInput: null,
        }
    },

    computed: {
        canMakePartialPayment() {
            // Paiements partiels autorisés seulement pour mois 2-10
            // OU si des paiements sont déjà pending (pour refaire un paiement)
            if (!this.currentPayment) return false

            return (this.currentPayment.month_number > 1 && this.remainingAmount > 0) ||
                   (this.currentPayment.month_number > 1 && this.totalPendingAmount > 0)
        },

        finalAmount() {
            // Si paiement partiel activé et montant custom valide
            if ((this.canMakePartialPayment || this.totalPendingAmount > 0) && this.customAmount > 0) {
                return Math.min(this.customAmount, this.totalDue)
            }
            // Si amountToPay = 0 mais qu'on a des pending, utiliser le montant de base
            if (this.amountToPay <= 0 && this.totalPendingAmount > 0) {
                return this.currentPayment ? this.currentPayment.amount_due : this.totalDue
            }
            return this.amountToPay
        },

        isFormValid() {
            return this.phone_number &&
                   this.transaction_operator &&
                   this.finalAmount > 0 &&
                   this.phone_number !== 'Enter Phone Number'
        }
    },

    filters: {
        formatAmount(value) {
            if (!value) return '0'
            return new Intl.NumberFormat('fr-FR').format(value)
        }
    },

    mounted() {
        this.loadPaymentData()
        this.getPaymentRef()
        this.loadPendingTransactions() // 🔥 NOUVEAU
        document.title = "PettyCash | Make Payment"
    },

    methods: {
        async loadPaymentData() {
            this.$store.commit('setIsLoading', true)

            const investmentId = this.$route.params.investment_id
            const paymentId = this.$route.params.payment_id

            try {
                const response = await axios.get(`/api/v1/savings/investments/${investmentId}/payment-info/`, {
                    params: { payment_id: paymentId }
                })

                this.investment = response.data.investment
                this.paymentType = response.data.payment_type
                this.amountToPay = response.data.amount
                this.totalDue = response.data.amount

                if (paymentId) {
                    this.currentPayment = response.data.payment

                    // Calculer le montant restant
                    const amountDue = this.currentPayment.amount_due || 0
                    const penaltyApplied = this.currentPayment.penalty_applied || 0
                    const amountPaid = this.currentPayment.amount_paid || 0 // Montants VALIDÉS seulement

                    this.totalDue = amountDue + penaltyApplied

                    // 🔥 IMPORTANT: remainingAmount = ce qui reste à payer (hors pending)
                    // Les paiements pending ne comptent pas encore
                    this.remainingAmount = this.totalDue - amountPaid

                    // Si remainingAmount = 0, on met un montant par défaut pour permettre un nouveau paiement
                    // (au cas où le premier paiement pending est incorrect)
                    if (this.remainingAmount <= 0) {
                        // Montant suggéré = montant de base du mois
                        this.amountToPay = amountDue
                        this.remainingAmount = amountDue
                    } else {
                        this.amountToPay = this.remainingAmount
                    }

                    // Montant minimum pour paiement partiel
                    this.minPartialAmount = Math.max(
                        this.currentPayment.penalty_applied || 0,
                        5000 // Minimum absolu de 10,000 FCFA
                    )
                }
            } catch (error) {
                this.$store.commit('setSnackBarMessage', 'Error loading payment info')
                this.$store.commit('setSnackBarColor', 'red darken-4')
                this.$store.commit('activateSnackBar', true)

                setTimeout(() => this.$router.go(-1), 2000)
            } finally {
                this.$store.commit('setIsLoading', false)
            }
        },

        // 🔥 NOUVEAU: Charger les transactions en attente
        async loadPendingTransactions() {
            const investmentId = this.$route.params.investment_id
            const paymentId = this.$route.params.payment_id

            try {
                const response = await axios.get(`/api/v1/savings/investments/${investmentId}/pending-transactions/`, {
                    params: { payment_id: paymentId }
                })

                this.pendingTransactions = response.data.transactions || []
                this.totalPendingAmount = response.data.total_pending || 0
            } catch (error) {
                console.error('Error loading pending transactions:', error)
            }
        },

        async getPaymentRef() {
            const investmentId = this.$route.params.investment_id
            const paymentId = this.$route.params.payment_id

            try {
                const response = await axios.get(`/api/v1/savings/investments/${investmentId}/payment-ref/`, {
                    params: { payment_id: paymentId }
                })
                this.payment_ref = response.data.payment_ref
            } catch (error) {
                console.error('Error getting payment reference:', error)
            }
        },

        validateCustomAmount() {
            if (this.customAmount < this.minPartialAmount) {
                this.customAmount = this.minPartialAmount
            } else if (this.customAmount > this.totalDue) {
                this.customAmount = this.totalDue
            }
        },

        clearPhoneField() {
            if (this.phone_number === 'Enter Phone Number') {
                this.phone_number = ''
            }
        },

        selectMoMo() {
            this.momo_choice = true
            this.om_choice = false
            this.transaction_operator = 'MTN Mobile Money'
        },

        selectOM() {
            this.momo_choice = false
            this.om_choice = true
            this.transaction_operator = 'Orange Money'
        },

        goBack() {
            const investmentId = this.$route.params.investment_id
            this.$router.push({
                name: 'SavingsInvestismentDetail',
                params: { investment_id: investmentId }
            })
        },

        confirmPayment() {
            if (!this.isFormValid) {
                this.$store.commit('setSnackBarMessage', 'Please fill all required fields')
                this.$store.commit('setSnackBarColor', 'red darken-4')
                this.$store.commit('activateSnackBar', true)
                return
            }

            // Générer le code de transfert
            if (this.transaction_operator === 'MTN Mobile Money') {
                this.transfer_code = `*126*4*${this.$store.state.MerchantCodeMTN}*${this.finalAmount}#`
                const href_tel = `tel:*126*4*${this.$store.state.MerchantCodeMTN}*${this.finalAmount}%23`
                document.getElementById('dial_transaction').setAttribute('href', href_tel)
                document.getElementById('dial_transaction').setAttribute('target', '_blank')
            } else {
                this.transfer_code = `#150*47*${this.$store.state.MerchantCodeOrange}*${this.finalAmount}#`
                const href_tel = `tel:%23150*47*${this.$store.state.MerchantCodeOrange}*${this.finalAmount}%23`
                document.getElementById('dial_transaction').setAttribute('href', href_tel)
                document.getElementById('dial_transaction').setAttribute('target', '_blank')
            }

            this.confirmDialog = true
        },

        async submitPayment() {
            this.isProcessing = true
            this.$store.commit('setIsLoading', true)

            const formData = new FormData()
            formData.append('payment_ref', this.payment_ref)
            formData.append('amount', this.finalAmount)
            formData.append('phone_number', this.phone_number)
            formData.append('transaction_operator', this.transaction_operator)

            const investmentId = this.$route.params.investment_id
            const paymentId = this.$route.params.payment_id

            try {
                const url = paymentId
                    ? `/api/v1/savings/investments/${investmentId}/pay-monthly/${paymentId}/`
                    : `/api/v1/savings/investments/${investmentId}/pay-onetime/`

                const response = await axios.post(url, formData)

                if (response.data.success) {
                    this.$store.commit('setSnackBarMessage', response.data.message)
                    this.$store.commit('setSnackBarColor', 'teal darken-2')
                    this.$store.commit('activateSnackBar', true)

                    // Show verification popup using store
                    this.$store.commit('showPaymentVerification', {
                        amount: this.finalAmount,
                        operator: this.transaction_operator,
                        phoneNumber: this.phone_number,
                        feature: 'investment',
                        id: investmentId
                    })
                } else {
                    throw new Error(response.data.message || 'Payment failed')
                }
            } catch (error) {
                const message = error.response?.data?.message || error.message || 'Payment error'
                this.$store.commit('setSnackBarMessage', message)
                this.$store.commit('setSnackBarColor', 'red darken-4')
                this.$store.commit('activateSnackBar', true)
            } finally {
                this.isProcessing = false
                this.$store.commit('setIsLoading', false)
                this.confirmDialog = false
            }
        }
    }
}
</script>

<style scoped>
.payment-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}

.info-item {
    display: flex;
    align-items: center;
}

.operator-card {
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
}

.operator-card:hover {
    transform: translateY(-3px);
    border-color: #00897b;
}

.operator-card.selected {
    border-color: #00897b;
    background: #e0f2f1;
    box-shadow: 0 4px 12px rgba(0, 137, 123, 0.2);
}
</style>